import * as actionTypes from './actionTypes';

const initialState = {
  error: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SHOW_MODAL:
      return {
        ...state,
        error: {
          name: action.name,
          message: action.message,
        },
      };
    default:
      return state;
  }
};
